<template>
    <div
        class="bubble bg-secondary h-12 w-12 rounded-full p-1"
        @click="flyTo"
    >
        <span><a
                href="javascript:void(0)"
                class="bubble_link"
            ><img :src="cluster.properties.marker_image_url" loading="lazy" class="inline rounded-full"/></a></span>
        <div class="count_box">{{ cluster.properties.point_count }}</div>
    </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
    props: {
        cluster: {
            type: Object,
            required: true,
        },
        mySmartMap: {
            type: Object,
            default: function () {
                return null;
            },
        },
        clusterMarkers: {
            type: Array,
            required: true
        }
    },
    methods: {
        flyTo() {
            this.mySmartMap.flyTo({
                center: this.cluster.geometry.coordinates,
                zoom: this.mySmartMap.getZoom() + 2,
                speed: 1.8
            });
        },
    },
    mounted() {
        const marker = new mapboxgl.Marker(this.$el)
            .setLngLat(this.cluster.geometry.coordinates)
            .addTo(this.mySmartMap);
        this.clusterMarkers.push(marker)
    }
};
</script>

<style>
</style>